import { render, staticRenderFns } from "./AtaList.vue?vue&type=template&id=3286ff20&"
import script from "./AtaList.vue?vue&type=script&lang=js&"
export * from "./AtaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports